module.exports = __webpack_public_path__ + "img/logo-web.229b690d.svg";